import {
  actionTypes,
  emergencyRequestListSuccess,
  emergencyRequestListFailure,
  createRequestSuccess,
  createRequestFailure,
} from "./actions";
import { fetchEmergencyUsersList, fetchCreateRequest } from "./services";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { IRequestItemRow } from "../../../models/Request";

const fetchEmergencyListRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EMERGENCY_REQUEST_LIST_REQUEST),
    mergeMap(() =>
      fetchEmergencyUsersList().pipe(
        map((response: IRequestItemRow[]) =>
          emergencyRequestListSuccess(response)
        ),
        catchError((error: any) => of(emergencyRequestListFailure(error)))
      )
    )
  );

const fetchCreateRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_REQUEST_EMERGENCY_USER),
    mergeMap((action: any) =>
      fetchCreateRequest(action.payload).pipe(
        map((response: IRequestItemRow[]) => createRequestSuccess(response)),
        catchError((error: any) => of(createRequestFailure(error)))
      )
    )
  );
export default [fetchEmergencyListRequestsEpic, fetchCreateRequestsEpic];
